export enum Categories {
  GENERAL = 'General',

  EDIT_STUDY = 'Edit Study',
  STUDY = 'Study',
  SETTINGS = 'Settings',
  PANEL = 'Panel',
  STUDY_CREATION = 'Study Creation',
  BILLING = 'Billing',
  SPECIAL_OFFER = 'Special Offer',
  SUBSCRIBE_PANEL = 'Subscibe To Panel',
  PERSONA = 'Persona',
  FORGOT_PASSWORD = 'Forgot Password',
  SIGNUP = 'Signup',
  LOGIN = 'Login',

  PARTICIPANT = 'Participant',
  PARTICIPATION_SUMMARY = 'Participation Summary',
  ADD_PANEL_INFO = 'Add Panel Info',

  SURVEY = 'Survey',
  NOT_READY = 'Not Ready',
  RECRUIT = 'Recruit Participants',
}
